import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const Loading = () => {
  return (
    <Box sx={{ display: 'flex', position: 'absolute', top: '30%', right: '50%' }}>
      <CircularProgress />
    </Box>
  );
};
